import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './Home'
import Terminal from './Terminal'
import TV from './TV'
import VP from './VP'
import ManageLegacy from './ManageLegacy'
import ManageCentralLegacy from './ManageCentralLegacy'
import Manage from './Manage'
import ManageCentral from './ManageCentral'
import Manage2 from './Manage2'
import ManageTopLegacy from './ManageTopLegacy'
import ManageTop from './ManageTop'
import Buzzers from './Buzzers'
import Com from './Com.js'
import MagicData from './MagicData.js'

window.addEventListener('error', function(event) {
	try {
		Com.setVariable('', 'javaScriptError', window.location+' '+event.error.stack)
	}
	catch(err) {
		console.log(err)
	}
}, true)

window.addEventListener('unhandledrejection', function(event) {
	try {
		Com.setVariable('', 'javaScriptError', window.location+' '+event.reason)
	}
	catch(err) {
		console.log(err)
	}
}, true)

let inverseKaraWorldTVAndVPMagicData = MagicData.newMagicData()

let initialized = false
function init() {
	initialized = true
	Com.connectMagicData(inverseKaraWorldTVAndVPMagicData, '', 'inverseKaraWorldTVAndVP')
}

function Main() {
	const [comConnected, setComConnected] = React.useState(false)
	const [inverseKaraWorldTVAndVP, setinverseKaraWorldTVAndVP] = React.useState(inverseKaraWorldTVAndVPMagicData.getValue())
	inverseKaraWorldTVAndVPMagicData.addChangeCb(setinverseKaraWorldTVAndVP)
	Com.connectedMagicData.addChangeCb(setComConnected)
	Com.connectedMagicData.addChangeCb(init)
	if (!comConnected) return (
		<div></div>
	)
	else return (
		<Routes>
			<Route path='/' element={<Home/>}></Route>
			<Route path='/terminal' element={<Terminal/>}></Route>
			{inverseKaraWorldTVAndVP ? <Route path='/tv' element={<VP/>}></Route> : <Route path='/tv' element={<TV/>}></Route>}
			{inverseKaraWorldTVAndVP ? <Route path='/vp' element={<TV/>}></Route> : <Route path='/vp' element={<VP/>}></Route>}
			<Route path='/managelegacy' element={<ManageLegacy/>}></Route>
			<Route path='/managecentrallegacy' element={<ManageCentralLegacy/>}></Route>
			<Route path='/manage' element={<Manage/>}></Route>
			<Route path='/managecentral' element={<ManageCentral/>}></Route>
			<Route path='/manage2' element={<Manage2/>}></Route>
			<Route path='/managetoplegacy' element={<ManageTopLegacy/>}></Route>
			<Route path='/managetop' element={<ManageTop/>}></Route>
			<Route path='/buzzers' element={<Buzzers/>}></Route>
		</Routes>
	)
}

export default Main
